import React, { useEffect, useState } from "react";
import CommonModal from "../../UiKits/Modals/common/modal";
import { Descriptions, Tabs } from "antd";
import CoursesTab from "./CoursesTab";
import Quizzestab from "./Quizzestab";

const { TabPane } = Tabs;

const UserDetail = ({ detailsModel: { details, show }, setDetailsModel, students, setStudents }) => {
  const [activeUser, setActiveUser] = useState();
  const renderDetailsItem = (label, content) => (
    <Descriptions.Item label={<span>{label}</span>}>
      <span>{content}</span>
    </Descriptions.Item>
  );
  useEffect(() => {
    setActiveUser(details)
  }, [details])
  const closeUserDetail = () => {
    setDetailsModel({
      show: false,
      details: {}
    })
  }
  if (!activeUser) return null;

  return (
    <CommonModal
      isOpen={show}
      toggler={closeUserDetail}
      showCloseBtn={true}
      successText={'Close'}
      title={details.email}
      success={closeUserDetail}
      bodyClass='full-screen-modal'
      size="lg"
      data={activeUser}
      setData={setActiveUser}
      students={students}
      setStudents={setStudents}
    >
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            key: "1",
            label: "Info",
            children: (
              <div className="user-details-modals">
                <div>
                  <Descriptions bordered column={1} style={{ width: "100%" }}>
                    {renderDetailsItem("Student Id", activeUser.studentId)}
                    {renderDetailsItem("Name", activeUser.fullName)}
                    {renderDetailsItem("Student Email", activeUser.email)}
                    {renderDetailsItem("Contact No", activeUser.contactNo)}
                    {renderDetailsItem("CNIC", activeUser.cnicNo)}
                    {renderDetailsItem("Age", activeUser.age)}
                    {renderDetailsItem("Gender", activeUser.gender)}
                    {renderDetailsItem("Qualification", activeUser.qualification)}
                    {renderDetailsItem("How You Know", activeUser.howYouKnow)}
                  </Descriptions>
                </div>
                <div className="user-image">
                  {activeUser.userProfileImage && (
                    <img src={activeUser.userProfileImage} alt="Profile" style={{borderRadius: "8px", width:"100%" }}  />
                  )}
                </div>
              </div>
            ),
          },
          {
            key: "2",
            label: "Courses",
            children: <CoursesTab data={activeUser} />,
          },
          {
            key: "3",
            label: "Quizzes",
            children: <Quizzestab data={activeUser} />,
          },
        ]}
      />

    </CommonModal>
  );
};

export default UserDetail;
